export const isCurrentPage = (hideCommandPath: string | null, pathname: string): boolean => {
	const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');

	const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');

	return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
};
